import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// AuthCallback handles the Emergent OAuth return where `#session_id=...` is in the URL fragment.
// It exchanges the session_id for our own session_token cookie via /api/auth/session and then
// navigates to the main app.
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(r.data);
        // Strip fragment and go home
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(t("final.google_success"));
        nav("/", { replace: true });
      } catch (e) {
        toast.error(t("final.google_failed"));
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F172A] text-white" data-testid="auth-callback">
      <div className="text-center space-y-3">
        <div className="w-10 h-10 border-2 border-white/20 border-t-white rounded-full animate-spin mx-auto" />
        <div className="font-mono text-sm text-slate-300">{t("final.google_verifying")}</div>
      </div>
    </div>
  );
}
